<template>
  <div class="main">
    <report-top> </report-top>
    <div id="formTable">
      <div id="text">网格列表</div>
      <div id="ddas">
        <!-- <Button @click="reOpenWin" type="primary" size="small" icon="md-cloud-download">导出</Button>-->
        <Button @click="openAdd" type="primary" size="small" icon='md-add'>新增</Button>
      </div>
    </div>

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
    >
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="openPerson(row, index)">分派人员</Button>
        <Button size="small" @click="opemUpdate(row, index)">编辑</Button>
        <Button size="small" @click="del(row, 1)">删除</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <Modal
      v-model="openForm"
      :title="isAdd ? '新增网格' : '编辑网格'"
      footer-hide
      fullscreen
      @on-cancel="cliclCancelBtn"
    >
      <div style="width: 100%; height: 100%; position: relative">
        <duobianxing ref="duobianxing"></duobianxing>
        <div id="aecwc">
          <Form
            ref="item"
            :model="item"
            :rules="ruleValidate"
            :label-width="80"
          >
            <Row :gutter="16">
              <Col span="24">
                <FormItem label="网格名称" prop="name">
                  <Input v-model="item.name" placeholder="请输入"></Input>
                </FormItem>
              </Col>
              <Col span="24">
                <FormItem label="网格编号" prop="code">
                  <Input v-model="item.code" placeholder="请输入"></Input>
                </FormItem>
              </Col>
              <Col span="24">
                <FormItem label="所属部门" prop="groupName">
                  <selectGroup
                    :name="item.groupName"
                    @update:name="item.groupName = $event"
                    :id="item.groupId"
                    @update:id="item.groupId = $event"
                  >
                  </selectGroup>
                </FormItem>
              </Col>
              <Col span="24">
                <FormItem label="业务类型" prop="businessType">
                  <Select v-model="item.businessType">
                    <Option
                      v-for="(x, index) in $t('businessType')"
                      :value="x"
                      :key="index"
                      >{{ x }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
              <Col span="24">
                <FormItem label="网格类型" prop="type">
                  <Select v-model="item.type" style="width: 100%">
                    <Option
                      v-for="(x, index) in $t('weilan')"
                      :value="index"
                      :key="index"
                      >{{ x }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
            </Row>
            <Row type="flex" justify="end">
              <Col span="24">
                <Button type="primary" long @click="addUpdate('item')"
                  >提交表单</Button
                >
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    </Modal>
    <personList ref="personList"></personList>
  </div>
</template>
<script>
import axios from "axios";
import duobianxing from "../map/duobianxing.vue";
import personList from "./personList.vue"
export default {
  components: { duobianxing,personList },
  data() {
    return {
      openForm: false,
      isAdd: false,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "网格名称",
          key: "name",
        },
        {
          title: "网格编号",
          key: "code",
        },
         {
          title: "网格类型",
          key: "type",
          render: (h, data) => {
            return h("div", this.$t("weilan." + data.row.type));
          },
        },
        {
          title: "业务类型",
          key: "businessType",
        },
        {
          title: "创建者账号",
          key: "createAccount",
        },
        {
          title: "创建时间",
          key: "createTime",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.createTime, "yymmdd"));
          },
        },
        {
          title: "操作",
          slot: "action",
          width: 180,
          align: "center",
          fixed: "right",
        },
      ],
      tableData: [],
      item: {
        groupId: 0,
        groupName: "",
        name: "",
        code: "",
        type: "0", //网格类型(0-车辆,1-人员)
        businessType: "清扫保洁", //业务类型（清扫保洁,垃圾清运,综合巡查,绿化管养）
        pointType: 2, //坐标类型（1-大地坐标系-WGS84，2-火星坐标系-GCJ-02，3-百度坐标系-BD-09）
        regionList: [],
        manager: "",
        tel: "",
        address: "",
      },
      ruleValidate: {
        name: { required: true, message: "必填" },
        code: { required: true, message: "必填" },
        businessType: { required: true, message: "必填" },
        type: { required: true, message: "必填" },
        groupName: { required: true, message: "必填" },
      },
      pageNumber: 1,
      pageSize: 50,
      total: 0,
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.swm + "/grid/list",
        data: {},
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        this.tableData = data;
        console.log(data);
      });
    },
    addUpdate(name) {
      var ccc = this.$refs.duobianxing.getPoints();
      this.item.regionList = ccc;
      console.log(this.item);
      this.$refs[name].validate((valid) => {
        if (valid) {
          if (this.isAdd) {
            axios({
              method: "post",
              url: axios.swm + "/grid/add",
              data: this.item,
            }).then((res) => {
              console.log(res);
              if (res) {
              this.openForm = false;
              this.getList();
            }
            });
          } else {
            axios({
              method: "post",
              url: axios.swm + "/grid/update",
              data: this.item,
            }).then((res) => {
              if (res) {
              this.openForm = false;
              this.getList();
            }
            });
          }
        }
      });
    },
    //删除公司
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          axios({
            method: "post",
            url: axios.swm + "/grid/del",
            data: { idList: [row.id] },
          }).then((res) => {
            console.log(res);
            this.getList();
          });
        },
      });
    },
    //点击编辑按钮
    opemUpdate(row) {
      this.openForm = true;
      this.isAdd = false;
      this.item = row;
      setTimeout(() => {
        this.$refs.duobianxing.reData(row.regionList)
      }, 500);
      
    },
    openAdd() {
      this.openForm = true;
      this.isAdd = true;
    },
    resetForm() {
      this.$refs["item"].resetFields();
    },
    cliclCancelBtn() {
      this.openForm = false;
      var arr = this.tableData;
      this.tableData = [];
      setTimeout(() => {
        this.tableData = arr;
      }, 200);
    },
    changePage(x) {
      this.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.pageSize = x;
      this.getList();
    },
    openPerson(v){
      this.$refs.personList.open(v);
    }
  },
  mounted() {
    this.getList();
  },
};
</script>
<style>
#aecwc {
  position: absolute;
  width: 240px;
  background: #fff;
  z-index: 3;
  top: 10px;
  right: 10px;
  padding: 15px;
}
</style>


// WEBPACK FOOTER //
// src/components/person/wangge.vue